export const CANVAS_STATE = 'CANVAS_STATE';
export const REMOVE_PAGE = 'REMOVE_PAGE';
export const CHANGE_PAGE = 'CHANGE_PAGE';
